window.jobberYMM = {
  "Toyota": {
    "Tacoma": [
      "2026",
      "2025",
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995"
    ],
    "4Runner": [
      "2025",
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992",
      "1991",
      "1990",
      "1989",
      "1988",
      "1987",
      "1986"
    ],
    "Tundra": [
      "2026",
      "2025",
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000"
    ],
    "Hilux": [
      "2020",
      "2019",
      "2018"
    ],
    "Sequoia": [
      "2025",
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001"
    ],
    "Land-Cruiser": [
      "2025",
      "2024",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979",
      "1978",
      "1977",
      "1976",
      "1975",
      "1974",
      "1973",
      "1972",
      "1971",
      "1970",
      "1969",
      "1968",
      "1967",
      "1966",
      "1965",
      "1964",
      "1963",
      "1962",
      "1961",
      "1960"
    ],
    "Pickup": [
      "1995",
      "1994",
      "1993",
      "1992",
      "1991",
      "1990",
      "1989",
      "1988",
      "1987",
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979"
    ],
    "FJ-Cruiser": [
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003"
    ],
    "T100": [
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993"
    ],
    "RAV4": [
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013"
    ],
    "Highlander": [
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014"
    ]
  },
  "Nissan": {
    "Frontier": [
      "2025",
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998"
    ],
    "Titan": [
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004"
    ],
    "TITAN": [
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004"
    ],
    "Armada": [
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005"
    ],
    "TITAN-XD": [
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016"
    ],
    "Titan-XD": [
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016"
    ],
    "Pathfinder": [
      "1995",
      "1994",
      "1993",
      "1992",
      "1991",
      "1990",
      "1989",
      "1988",
      "1987"
    ],
    "D21": [
      "1994",
      "1993",
      "1992",
      "1991",
      "1990",
      "1989",
      "1988",
      "1987",
      "1986"
    ],
    "Rogue": [
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011"
    ],
    "Xterra": [
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000"
    ],
    "D21-Hardbody-Pickup": [
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992",
      "1991",
      "1990",
      "1989",
      "1988",
      "1987",
      "1986"
    ]
  },
  "GMC": {
    "Sierra-1500": [
      "2025",
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999"
    ],
    "Sierra-2500-HD": [
      "2025",
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001"
    ],
    "Sierra-3500-HD": [
      "2025",
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007"
    ],
    "Sierra-3500": [
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001"
    ],
    "K15/K1500-Suburban": [
      "1974",
      "1973",
      "1972",
      "1971",
      "1970"
    ],
    "K35/K3500-Pickup": [
      "1974",
      "1973",
      "1972",
      "1971",
      "1970"
    ],
    "Jimmy": [
      "1991",
      "1990",
      "1989",
      "1988",
      "1987",
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979",
      "1978",
      "1977",
      "1976",
      "1975",
      "1974",
      "1973",
      "1972",
      "1971",
      "1970"
    ],
    "K15/K1500-Pickup": [
      "1974",
      "1973",
      "1972",
      "1971",
      "1970"
    ],
    "K25/K2500-Suburban": [
      "1974",
      "1973",
      "1972",
      "1971",
      "1970"
    ],
    "K25/K2500-Pickup": [
      "1974",
      "1973",
      "1972",
      "1971",
      "1970"
    ],
    "Canyon": [
      "2025",
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004"
    ],
    "K15": [
      "1978",
      "1977",
      "1976",
      "1975"
    ],
    "Yukon-XL": [
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015"
    ],
    "Yukon-XL-1500": [
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000"
    ],
    "K1500-Suburban": [
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992"
    ],
    "K1500": [
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992",
      "1991",
      "1990",
      "1989",
      "1988",
      "1987",
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979"
    ],
    "Yukon": [
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992"
    ],
    "K15-Suburban": [
      "1978",
      "1977",
      "1976",
      "1975"
    ],
    "V1500": [
      "1987"
    ],
    "Sierra-1500-Classic": [
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007"
    ],
    "Sierra-1500-AT4X": [
      "2024",
      "2023",
      "2022"
    ],
    "Sierra-1500-Limited": [
      "2019"
    ],
    "K25": [
      "1978",
      "1977",
      "1976",
      "1975"
    ],
    "K25-Suburban": [
      "1978",
      "1977",
      "1976",
      "1975"
    ],
    "K2500": [
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979"
    ],
    "K2500-Suburban": [
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979"
    ],
    "S15": [
      "1990",
      "1989",
      "1988",
      "1987",
      "1986",
      "1985",
      "1984",
      "1983",
      "1982"
    ],
    "Sonoma": [
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992",
      "1991"
    ],
    "S15-Jimmy": [
      "1991",
      "1990",
      "1989",
      "1988",
      "1987",
      "1986",
      "1985",
      "1984",
      "1983"
    ],
    "Sierra-2500": [
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999"
    ],
    "Sierra-1500-HD": [
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001"
    ],
    "Sierra-2500HD": [
      "2025",
      "2024",
      "2023",
      "2022",
      "2021",
      "2020"
    ],
    "Sierra-3500HD": [
      "2025",
      "2024",
      "2023",
      "2022",
      "2021",
      "2020"
    ],
    "Envoy": [
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002"
    ],
    "C1500": [
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992",
      "1991",
      "1990",
      "1989",
      "1988",
      "1987",
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979"
    ],
    "Sierra-2500-HD-Classic": [
      "2007"
    ],
    "Sierra-3500-Classic": [
      "2007"
    ],
    "C1500-Suburban": [
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992"
    ],
    "C2500-Suburban": [
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992",
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979"
    ],
    "Yukon-XL-2500": [
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000"
    ],
    "C3500": [
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992",
      "1991",
      "1990",
      "1989",
      "1988",
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979"
    ],
    "K3500": [
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992",
      "1991",
      "1990",
      "1989",
      "1988",
      "1987",
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979"
    ],
    "C35": [
      "1978",
      "1977"
    ],
    "K35": [
      "1978",
      "1977"
    ],
    "C15-Suburban": [
      "1978",
      "1977",
      "1976",
      "1975"
    ],
    "C15/C1500-Suburban": [
      "1974",
      "1973",
      "1972",
      "1971",
      "1970"
    ],
    "C15/C1500-Pickup": [
      "1974",
      "1973",
      "1972",
      "1971",
      "1970"
    ],
    "C15": [
      "1978",
      "1977",
      "1976",
      "1975"
    ],
    "R1500": [
      "1987"
    ],
    "C2500": [
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979"
    ],
    "C25/C2500-Suburban": [
      "1974",
      "1973",
      "1972",
      "1971",
      "1970"
    ],
    "C25": [
      "1978",
      "1977",
      "1976",
      "1975"
    ],
    "C25-Suburban": [
      "1978",
      "1977",
      "1976",
      "1975"
    ],
    "C25/C2500-Pickup": [
      "1974",
      "1973",
      "1972",
      "1971",
      "1970"
    ],
    "Acadia": [
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017"
    ],
    "C1500/K1500-Pickup": [
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992",
      "1991",
      "1990",
      "1989",
      "1988"
    ],
    "C1500/K1500-Suburban": [
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992"
    ],
    "C2500/K2500-Pickup": [
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992",
      "1991",
      "1990",
      "1989",
      "1988"
    ],
    "C2500/K2500-Suburban": [
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992"
    ],
    "C3500/K3500-Pickup": [
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992",
      "1991",
      "1990",
      "1989",
      "1988"
    ],
    "Sierra-2500-Classic": [
      "2007"
    ],
    "C15/K15-Pickup": [
      "1987",
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979",
      "1978",
      "1977",
      "1976",
      "1975",
      "1974",
      "1973",
      "1972",
      "1971",
      "1970",
      "1969"
    ],
    "C15/K15-Suburban": [
      "1991",
      "1990",
      "1989",
      "1988",
      "1987",
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979",
      "1978",
      "1977",
      "1976",
      "1975",
      "1974",
      "1973",
      "1972",
      "1971",
      "1970",
      "1969"
    ],
    "C25/K25-Pickup": [
      "1987",
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979",
      "1978",
      "1977",
      "1976",
      "1975",
      "1974",
      "1973",
      "1972",
      "1971",
      "1970",
      "1969"
    ],
    "C25/K25-Suburban": [
      "1991",
      "1990",
      "1989",
      "1988",
      "1987",
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979",
      "1978",
      "1977",
      "1976",
      "1975",
      "1974",
      "1973",
      "1972",
      "1971",
      "1970",
      "1969"
    ],
    "C35/K35-Pickup": [
      "1987",
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979",
      "1978",
      "1977",
      "1976",
      "1975",
      "1974",
      "1973",
      "1972",
      "1971",
      "1970",
      "1969"
    ],
    "S15-Pickup": [
      "1990",
      "1989",
      "1988",
      "1987",
      "1986",
      "1985",
      "1984",
      "1983",
      "1982"
    ]
  },
  "Chevy": {
    "Silverado-1500": [
      "2026",
      "2025",
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999"
    ],
    "Silverado-3500-HD": [
      "2025",
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007"
    ],
    "Silverado-3500": [
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001"
    ],
    "Silverado-2500-HD": [
      "2025",
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001"
    ],
    "K20-Pickup": [
      "1974",
      "1973",
      "1972",
      "1971",
      "1970",
      "1969"
    ],
    "Blazer": [
      "1994",
      "1993",
      "1992",
      "1991",
      "1990",
      "1989",
      "1988",
      "1987",
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979",
      "1978",
      "1977",
      "1976",
      "1975",
      "1974",
      "1973",
      "1972",
      "1971",
      "1970",
      "1969"
    ],
    "K10-Suburban": [
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979",
      "1978",
      "1977",
      "1976",
      "1975",
      "1974",
      "1973",
      "1972",
      "1971",
      "1970",
      "1969"
    ],
    "K10-Pickup": [
      "1974",
      "1973",
      "1972",
      "1971",
      "1970",
      "1969"
    ],
    "K20-Suburban": [
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979",
      "1978",
      "1977",
      "1976",
      "1975",
      "1974",
      "1973",
      "1972",
      "1971",
      "1970",
      "1969"
    ],
    "K30-Pickup": [
      "1974",
      "1973",
      "1972",
      "1971",
      "1970",
      "1969"
    ],
    "Colorado": [
      "2025",
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004"
    ],
    "V10-Suburban": [
      "1988",
      "1987"
    ],
    "Suburban": [
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007"
    ],
    "Avalanche": [
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007"
    ],
    "Avalanche-1500": [
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002"
    ],
    "K5-Blazer": [
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979",
      "1978",
      "1977",
      "1976",
      "1975"
    ],
    "Tahoe": [
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995"
    ],
    "Silverado-1500-Classic": [
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007"
    ],
    "Suburban-1500": [
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000"
    ],
    "V10": [
      "1987"
    ],
    "K10": [
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979",
      "1978",
      "1977",
      "1976",
      "1975"
    ],
    "K1500": [
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992",
      "1991",
      "1990",
      "1989",
      "1988"
    ],
    "K1500-Suburban": [
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992"
    ],
    "V1500-Suburban": [
      "1991",
      "1990",
      "1989"
    ],
    "Silverado-1500-LD": [
      "2019"
    ],
    "V20-Suburban": [
      "1988",
      "1987"
    ],
    "K20": [
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979",
      "1978",
      "1977",
      "1976",
      "1975"
    ],
    "S10-Blazer": [
      "1994",
      "1993",
      "1992",
      "1991",
      "1990",
      "1989",
      "1988",
      "1987",
      "1986",
      "1985",
      "1984",
      "1983"
    ],
    "S10": [
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992",
      "1991",
      "1990",
      "1989",
      "1988",
      "1987",
      "1986",
      "1985",
      "1984",
      "1983",
      "1982"
    ],
    "Silverado-1500-HD": [
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001"
    ],
    "Silverado-2500": [
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999"
    ],
    "K3500": [
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992",
      "1991",
      "1990",
      "1989",
      "1988"
    ],
    "K2500": [
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992",
      "1991",
      "1990",
      "1989",
      "1988"
    ],
    "K2500-Suburban": [
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992"
    ],
    "Silverado-2500HD": [
      "2025",
      "2024",
      "2023",
      "2022",
      "2021",
      "2020"
    ],
    "Silverado-3500HD": [
      "2025",
      "2024",
      "2023",
      "2022",
      "2021",
      "2020"
    ],
    "C1500-Suburban": [
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992"
    ],
    "Trailblazer": [
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002"
    ],
    "C1500": [
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992",
      "1991",
      "1990",
      "1989",
      "1988"
    ],
    "Silverado-3500-Classic": [
      "2007"
    ],
    "Silverado-2500-HD-Classic": [
      "2007"
    ],
    "C2500": [
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992",
      "1991",
      "1990",
      "1989",
      "1988"
    ],
    "Avalanche-2500": [
      "2006",
      "2005",
      "2004",
      "2003",
      "2002"
    ],
    "Suburban-2500": [
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000"
    ],
    "C2500-Suburban": [
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992"
    ],
    "C10-Pickup": [
      "1974",
      "1973",
      "1972",
      "1971",
      "1970",
      "1969"
    ],
    "C10": [
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979",
      "1978",
      "1977",
      "1976",
      "1975"
    ],
    "R10": [
      "1987"
    ],
    "K30": [
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979",
      "1978",
      "1977"
    ],
    "C30": [
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979",
      "1978",
      "1977"
    ],
    "R20-Suburban": [
      "1988",
      "1987"
    ],
    "C20-Pickup": [
      "1974",
      "1973",
      "1972",
      "1971",
      "1970",
      "1969"
    ],
    "C20-Suburban": [
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979",
      "1978",
      "1977",
      "1976",
      "1975",
      "1974",
      "1973",
      "1972",
      "1971",
      "1970",
      "1969"
    ],
    "R2500-Suburban": [
      "1991",
      "1990",
      "1989"
    ],
    "V2500-Suburban": [
      "1991",
      "1990",
      "1989"
    ],
    "C20": [
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979",
      "1978",
      "1977",
      "1976",
      "1975"
    ],
    "R1500-Suburban": [
      "1991",
      "1990",
      "1989"
    ],
    "R10-Suburban": [
      "1988",
      "1987"
    ],
    "C10-Suburban": [
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979",
      "1978",
      "1977",
      "1976",
      "1975",
      "1974",
      "1973"
    ],
    "C1500/K1500-Pickup": [
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992",
      "1991",
      "1990",
      "1989",
      "1988"
    ],
    "C1500/K1500-Suburban": [
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992"
    ],
    "C2500/K2500-Pickup": [
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992",
      "1991",
      "1990",
      "1989",
      "1988"
    ],
    "C2500/K2500-Suburban": [
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992"
    ],
    "C3500/K3500-Pickup": [
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992",
      "1991",
      "1990",
      "1989",
      "1988"
    ],
    "K1500-Blazer": [
      "1994",
      "1993",
      "1992"
    ],
    "Silverado-2500-Classic": [
      "2007"
    ],
    "S10-Pickup": [
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992",
      "1991",
      "1990",
      "1989",
      "1988",
      "1987",
      "1986",
      "1985",
      "1984",
      "1983",
      "1982"
    ],
    "C10/K10-Pickup": [
      "1987",
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979",
      "1978",
      "1977",
      "1976",
      "1975",
      "1974",
      "1973",
      "1972",
      "1971",
      "1970",
      "1969"
    ],
    "C10/K10-Suburban": [
      "1991",
      "1990",
      "1989",
      "1988",
      "1987",
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979",
      "1978",
      "1977",
      "1976",
      "1975",
      "1974",
      "1973",
      "1972",
      "1971",
      "1970",
      "1969"
    ],
    "C20/K20-Pickup": [
      "1987",
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979",
      "1978",
      "1977",
      "1976",
      "1975",
      "1974",
      "1973",
      "1972",
      "1971",
      "1970",
      "1969"
    ],
    "C20/K20-Suburban": [
      "1991",
      "1990",
      "1989",
      "1988",
      "1987",
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979",
      "1978",
      "1977",
      "1976",
      "1975",
      "1974",
      "1973",
      "1972",
      "1971",
      "1970",
      "1969"
    ],
    "C30/K30-Pickup": [
      "1987",
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979",
      "1978",
      "1977",
      "1976",
      "1975",
      "1974",
      "1973",
      "1972",
      "1971",
      "1970",
      "1969"
    ]
  },
  "Jeep": {
    "Comanche": [
      "1992",
      "1991",
      "1990",
      "1989",
      "1988",
      "1987",
      "1986"
    ],
    "Cherokee": [
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992",
      "1991",
      "1990",
      "1989",
      "1988",
      "1987",
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979",
      "1978",
      "1977",
      "1976",
      "1975",
      "1974"
    ],
    "Wrangler": [
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992",
      "1991",
      "1990",
      "1989",
      "1988",
      "1987"
    ],
    "Grand-Cherokee": [
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993"
    ],
    "Gladiator": [
      "2025",
      "2024",
      "2023",
      "2022",
      "2021",
      "2020"
    ],
    "Wrangler-JL-Unlimited": [
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014"
    ],
    "Wrangler-JL": [
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018"
    ],
    "Patriot": [
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010"
    ],
    "Compass": [
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007"
    ],
    "Gladiator-JT": [
      "2024",
      "2023",
      "2022",
      "2021",
      "2020"
    ],
    "CJ7": [
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979",
      "1978",
      "1977",
      "1976"
    ],
    "Scrambler": [
      "1985",
      "1984",
      "1983",
      "1982",
      "1981"
    ],
    "CJ5": [
      "1983",
      "1982",
      "1981",
      "1980",
      "1979",
      "1978",
      "1977",
      "1976",
      "1975",
      "1974",
      "1973",
      "1972",
      "1971",
      "1970",
      "1969",
      "1968",
      "1967",
      "1966",
      "1965",
      "1964",
      "1963",
      "1962",
      "1961",
      "1960",
      "1959"
    ],
    "J10": [
      "1988",
      "1987",
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979",
      "1978",
      "1977",
      "1976",
      "1975",
      "1974"
    ],
    "Grand-Wagoneer": [
      "1990",
      "1989",
      "1988",
      "1987",
      "1986",
      "1985",
      "1984"
    ],
    "J20": [
      "1988",
      "1987",
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979",
      "1978",
      "1977",
      "1976",
      "1975",
      "1974"
    ],
    "Wagoneer": [
      "1990",
      "1989",
      "1988",
      "1987",
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979",
      "1978",
      "1977",
      "1976",
      "1975",
      "1974",
      "1973",
      "1972"
    ],
    "Liberty": [
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002"
    ],
    "Commander": [
      "2010",
      "2009",
      "2008",
      "2007",
      "2006"
    ],
    "CJ-8-Scrambler": [
      "1985",
      "1984",
      "1983",
      "1982",
      "1981"
    ],
    "Cherokee-XJ": [
      "2001",
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992",
      "1991",
      "1990",
      "1989",
      "1988",
      "1987",
      "1986",
      "1985",
      "1984"
    ],
    "Comanche-MJ": [
      "1992",
      "1991",
      "1990",
      "1989",
      "1988",
      "1987",
      "1986"
    ],
    "Wrangler-JK-(2-Door)": [
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007"
    ],
    "Wrangler-JK-Unlimited": [
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007"
    ],
    "Wrangler-TJ": [
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997"
    ],
    "Wrangler-TJ-Unlimited": [
      "2006",
      "2005",
      "2004"
    ],
    "Wrangler-YJ": [
      "1995",
      "1994",
      "1993",
      "1992",
      "1991",
      "1990",
      "1989",
      "1988",
      "1987"
    ],
    "Renegade": [
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015"
    ],
    "Wrangler-4xe": [
      "2023",
      "2022",
      "2021"
    ],
    "Wrangler-JL-(2-Door)": [
      "2022",
      "2021",
      "2020",
      "2019",
      "2018"
    ]
  },
  "Ford": {
    "Ranger": [
      "2025",
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992",
      "1991",
      "1990",
      "1989",
      "1988",
      "1987",
      "1986",
      "1985",
      "1984",
      "1983"
    ],
    "F-250-Super-Duty": [
      "2025",
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999"
    ],
    "F-350-Super-Duty": [
      "2025",
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999"
    ],
    "F-150": [
      "2025",
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992",
      "1991",
      "1990",
      "1989",
      "1988",
      "1987",
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979",
      "1978",
      "1977",
      "1976",
      "1975"
    ],
    "F-150-Lightning": [
      "2025",
      "2024",
      "2023",
      "2022",
      "2021"
    ],
    "Bronco-Sport": [
      "2024",
      "2023",
      "2022",
      "2021"
    ],
    "Maverick": [
      "2025",
      "2024",
      "2023",
      "2022"
    ],
    "Bronco": [
      "2025",
      "2024",
      "2023",
      "2022",
      "2021",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992",
      "1991",
      "1990",
      "1989",
      "1988",
      "1987",
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979",
      "1978",
      "1977",
      "1976",
      "1975",
      "1974",
      "1973",
      "1972",
      "1971",
      "1970",
      "1969",
      "1968",
      "1967",
      "1966"
    ],
    "Expedition": [
      "2025",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997"
    ],
    "Explorer": [
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992",
      "1991"
    ],
    "F-450-Super-Duty": [
      "2024",
      "2023",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999"
    ],
    "F-250": [
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992",
      "1991",
      "1990",
      "1989",
      "1988",
      "1987",
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979",
      "1978",
      "1977",
      "1976",
      "1975",
      "1974",
      "1973",
      "1972",
      "1971",
      "1970",
      "1969",
      "1968",
      "1967",
      "1966",
      "1965",
      "1964",
      "1963",
      "1962",
      "1961",
      "1960",
      "1959",
      "1958",
      "1957",
      "1956",
      "1955",
      "1954",
      "1953"
    ],
    "Bronco-II": [
      "1990",
      "1989",
      "1988",
      "1987",
      "1986",
      "1985",
      "1984"
    ],
    "F-350": [
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992",
      "1991",
      "1990",
      "1989",
      "1988",
      "1987",
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979",
      "1978",
      "1977",
      "1976",
      "1975",
      "1974",
      "1973",
      "1972",
      "1971",
      "1970",
      "1969",
      "1968",
      "1967",
      "1966",
      "1965",
      "1964",
      "1963",
      "1962",
      "1961",
      "1960",
      "1959",
      "1958",
      "1957",
      "1956",
      "1955",
      "1954",
      "1953"
    ],
    "F-100": [
      "1983",
      "1982",
      "1981",
      "1980",
      "1979",
      "1978",
      "1977",
      "1976",
      "1975",
      "1974",
      "1973",
      "1972",
      "1971",
      "1970",
      "1969",
      "1968",
      "1967",
      "1966",
      "1965",
      "1964",
      "1963",
      "1962",
      "1961",
      "1960",
      "1959",
      "1958",
      "1957",
      "1956",
      "1955",
      "1954",
      "1953"
    ],
    "Excursion": [
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000"
    ],
    "Escape": [
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013"
    ],
    "Raptor": [
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010"
    ],
    "F-550-Super-Duty": [
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999"
    ]
  },
  "Dodge": {
    "W100-Pickup": [
      "1974",
      "1973",
      "1972",
      "1971",
      "1970",
      "1969",
      "1968"
    ],
    "W200-Pickup": [
      "1974",
      "1973",
      "1972",
      "1971",
      "1970",
      "1969",
      "1968",
      "1967",
      "1966",
      "1965",
      "1964",
      "1963",
      "1962",
      "1961",
      "1960",
      "1959",
      "1958",
      "1957"
    ],
    "W250": [
      "1993",
      "1992",
      "1991",
      "1990",
      "1989",
      "1988",
      "1987",
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981"
    ],
    "Ramcharger": [
      "1993",
      "1992",
      "1991",
      "1990",
      "1989",
      "1988",
      "1987",
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979",
      "1978",
      "1977",
      "1976",
      "1975",
      "1974"
    ],
    "Ram-2500": [
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994"
    ],
    "Ram-1500": [
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994"
    ],
    "Ram-3500": [
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994"
    ],
    "Durango": [
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011"
    ],
    "Raider": [
      "1989",
      "1988",
      "1987"
    ],
    "W150": [
      "1993",
      "1992",
      "1991",
      "1990",
      "1989",
      "1988",
      "1987",
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981",
      "1980",
      "1979",
      "1978",
      "1977"
    ],
    "W350": [
      "1993",
      "1992",
      "1991",
      "1990",
      "1989",
      "1988",
      "1987",
      "1986",
      "1985",
      "1984",
      "1983",
      "1982",
      "1981"
    ],
    "W300-Pickup": [
      "1974",
      "1973",
      "1972",
      "1971",
      "1970"
    ],
    "Dakota": [
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997",
      "1996",
      "1995",
      "1994",
      "1993",
      "1992",
      "1991",
      "1990",
      "1989",
      "1988",
      "1987"
    ]
  },
  "International": {
    "Scout-II": [
      "1980",
      "1979",
      "1978",
      "1977",
      "1976",
      "1975",
      "1974",
      "1973",
      "1972",
      "1971"
    ]
  },
  "Plymouth": {
    "Trailduster": [
      "1981",
      "1980",
      "1979",
      "1978",
      "1977",
      "1976",
      "1975",
      "1974"
    ]
  },
  "Ram": {
    "1500": [
      "2025",
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009"
    ],
    "2500": [
      "2025",
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010"
    ],
    "3500": [
      "2025",
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010"
    ],
    "1500-Classic": [
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019"
    ],
    "Dakota": [
      "2011"
    ],
    "1500-TRX": [
      "2022",
      "2021"
    ],
    "3500-Dually-Flatbed": [
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013"
    ]
  },
  "John-Deere": {
    "Gator-XUV-825i-4x4": [
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011"
    ],
    "Gator-XUV-825i-4x4-Power-Steering": [
      "2017",
      "2016",
      "2015",
      "2014",
      "2013"
    ],
    "Gator-XUV-825i-4x4-S4": [
      "2017",
      "2016",
      "2015",
      "2014",
      "2013"
    ],
    "Gator-XUV-825i-4x4-Special-Edition": [
      "2016"
    ],
    "Gator-XUV-625i-4x4": [
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011"
    ],
    "Gator-XUV-850D-4x4-Diesel": [
      "2010",
      "2009",
      "2008",
      "2007"
    ],
    "Gator-XUV-855D-4x4-Diesel": [
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011"
    ],
    "Gator-XUV-855D-4x4-Diesel-Power-Steering": [
      "2017",
      "2016",
      "2015",
      "2014",
      "2013"
    ],
    "Gator-XUV-855D-4x4-Diesel-S4": [
      "2017",
      "2016",
      "2015",
      "2014",
      "2013"
    ],
    "Gator-HPX-4x4": [
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004"
    ],
    "Gator-XUV-825E": [
      "2020",
      "2019",
      "2018"
    ],
    "Gator-XUV-825M": [
      "2020",
      "2019"
    ],
    "Gator-XUV-825M-S4": [
      "2022",
      "2021",
      "2020",
      "2019"
    ],
    "Gator-XUV-620i-4x4": [
      "2010",
      "2009",
      "2008",
      "2007"
    ]
  },
  "Honda": {
    "SXS1000M3-Pioneer-1000": [
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016"
    ],
    "SXS1000M5-Pioneer-1000-5": [
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016"
    ],
    "SXS1000M5-Pioneer-1000-5-Deluxe": [
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016"
    ],
    "SXS1000M3-Pioneer-1000-Limited-Edition": [
      "2021",
      "2019",
      "2018",
      "2017"
    ],
    "SXS1000M5-Pioneer-1000-5-Limited-Edition": [
      "2021",
      "2020",
      "2019",
      "2018",
      "2017"
    ],
    "SXS1000M3-Pioneer-1000-Deluxe": [
      "2024",
      "2023",
      "2022",
      "2021",
      "2020"
    ],
    "SXS10M6-Pioneer-1000-6-Deluxe-Crew": [
      "2024",
      "2023"
    ],
    "CR-V": [
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017"
    ],
    "SXS10S2R-Talon-1000R": [
      "2022",
      "2021",
      "2020",
      "2019"
    ],
    "SXS10S2X-Talon-1000X": [
      "2022",
      "2021",
      "2020",
      "2019"
    ],
    "SXS10S4-Talon-1000XS-4": [
      "2023"
    ],
    "SXS10S2R-Talon-1000RS": [
      "2023"
    ],
    "SXS10S4-Talon-1000X-4": [
      "2022",
      "2021",
      "2020"
    ],
    "SXS1000M5-Pioneer-1000-5-Forest": [
      "2024",
      "2023",
      "2022"
    ],
    "SXS1000M5-Pioneer-1000-5-Special-Edition": [
      "2021"
    ],
    "SXS1000M5-Pioneer-1000-5-Trail\\_x000D_\\": [
      "2024",
      "2023",
      "2022"
    ],
    "SXS520M2-Pioneer-520": [
      "2023",
      "2022",
      "2021"
    ],
    "SXS1000M3-Pioneer-1000-EPS": [
      "2019",
      "2018",
      "2017",
      "2016"
    ],
    "SXS1000M3-Pioneer-1000-Forest": [
      "2024",
      "2023",
      "2022"
    ],
    "SXS1000M3-Pioneer-1000-Special-Edition": [
      "2021"
    ],
    "SXS1000M3-Pioneer-1000-Trail": [
      "2024",
      "2023",
      "2022"
    ],
    "Ridgeline": [
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017"
    ],
    "SXS10S2X-Talon-1000XS": [
      "2023"
    ],
    "SXS1000M5-Pioneer-1000-5-Trail": [
      "2023",
      "2022"
    ],
    "SXS10S2R-Talon-1000R-Special-Edition": [
      "2021"
    ],
    "SXS10S2RD-Talon-1000R-FOX-Live-Valve": [
      "2022",
      "2021"
    ],
    "SXS10S2XD-Talon-1000X-FOX-Live-Valve": [
      "2022",
      "2021"
    ],
    "SXS10S4-Talon-1000X-4-FOX-Live-Valve": [
      "2022",
      "2021",
      "2020"
    ],
    "SXS10S4-Talon-1000X-4-Special-Edition": [
      "2021"
    ],
    "SXS10S4XD-Talon-1000XS-4-FOX-Live-Valve": [
      "2023"
    ],
    "TRX520FM1-FourTrax-Foreman-4x4": [
      "2022",
      "2021",
      "2020"
    ],
    "Pioneer-1000": [
      "2020",
      "2019",
      "2018",
      "2017",
      "2016"
    ]
  },
  "Cadillac": {
    "Escalade": [
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999"
    ]
  },
  "CFMOTO": {
    "UFORCE-U10-Pro\\_x000D_\\": [
      "2025"
    ],
    "UFORCE-U10-Pro": [
      "2025"
    ],
    "UFORCE-1000": [
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019"
    ],
    "UFORCE-1000-XL": [
      "2024",
      "2023",
      "2022"
    ],
    "UFORCE-600": [
      "2023",
      "2022",
      "2021"
    ]
  },
  "Polaris": {
    "Ranger-XP-1000-Big-Game-Edition": [
      "2022"
    ],
    "Ranger-XP-1000-High-Lifter-Edition": [
      "2022",
      "2021",
      "2020"
    ],
    "Ranger-XP-1000-NorthStar-Edition-Trail-Boss": [
      "2024",
      "2023",
      "2022",
      "2021"
    ],
    "Ranger-XP-1000-NorthStar-Premium": [
      "2024",
      "2023",
      "2022",
      "2021"
    ],
    "Ranger-XP-1000-NorthStar-Ultimate": [
      "2024",
      "2023",
      "2022",
      "2021"
    ],
    "Ranger-XP-1000-Premium": [
      "2024",
      "2023",
      "2022",
      "2021",
      "2020"
    ],
    "Ranger-XP-1000-Texas-Edition": [
      "2021",
      "2020",
      "2019"
    ],
    "Ranger-XP-1000-Trail-Boss": [
      "2022",
      "2021"
    ],
    "Ranger-XP-1000-Waterfowl-Edition": [
      "2022"
    ],
    "Ranger-Crew-XP-1000": [
      "2020",
      "2019",
      "2017"
    ],
    "Ranger-Crew-XP-1000-EPS": [
      "2019",
      "2018",
      "2017"
    ],
    "Ranger-Crew-XP-1000-EPS-Northstar-HVAC-Edition": [
      "2019",
      "2018",
      "2017"
    ],
    "Ranger-XP-1000": [
      "2020",
      "2019",
      "2018",
      "2017"
    ],
    "Ranger-Crew-XP-1000-EPS-20th-Anniversary": [
      "2019"
    ],
    "Ranger-Crew-XP-1000-EPS-Back-Country-Edition": [
      "2019"
    ],
    "Ranger-Crew-XP-1000-EPS-Northstar-Edition": [
      "2020"
    ],
    "Ranger-XP-1000-Northstar-Edition": [
      "2022",
      "2021",
      "2020",
      "2019"
    ],
    "Ranger-900-XP-Bronze-Mist-LE": [
      "2013"
    ],
    "Ranger-900-XP-LE": [
      "2013"
    ],
    "Ranger-900-XP-EPS-Browning-LE": [
      "2014",
      "2013"
    ],
    "Ranger-900-XP-EPS-LE": [
      "2015",
      "2014",
      "2013"
    ],
    "Ranger-900-XP": [
      "2017",
      "2016",
      "2015",
      "2014",
      "2013"
    ],
    "Ranger-900-XP-EPS": [
      "2017",
      "2016",
      "2015",
      "2014",
      "2013"
    ],
    "Ranger-900-XP-Deluxe": [
      "2014"
    ],
    "Ranger-900-XP-EPS-Deluxe": [
      "2015"
    ],
    "Ranger-900-XP-EPS-Hunter-Deluxe-Edition": [
      "2016",
      "2015"
    ],
    "Ranger-900-XP-EPS-Hunter-Edition": [
      "2016",
      "2015"
    ],
    "Ranger-900-XP-EPS-Northstar-Edition": [
      "2016",
      "2015"
    ],
    "Ranger-900-XP-EPS-Trail-Edition": [
      "2016"
    ],
    "Ranger-XP-1000-EPS-Hunter-Edition": [
      "2017"
    ],
    "Ranger-XP-1000-EPS-Ranch-Edition": [
      "2017"
    ],
    "Ranger-XP-1000-EPS": [
      "2019",
      "2018",
      "2017"
    ],
    "Ranger-XP-1000-EPS-Northstar-HVAC-Edition": [
      "2019",
      "2018",
      "2017"
    ],
    "Ranger-XP-900": [
      "2019",
      "2018"
    ],
    "Ranger-XP-900-EPS": [
      "2019",
      "2018"
    ],
    "Ranger-Crew-XP-1000-EPS-Premium": [
      "2019"
    ],
    "Ranger-XP-1000-EPS-20th-Anniversary": [
      "2019"
    ],
    "Ranger-XP-1000-EPS-Premium": [
      "2019"
    ],
    "Ranger-1000": [
      "2022",
      "2021",
      "2020"
    ],
    "Ranger-Crew-1000": [
      "2022",
      "2021",
      "2020"
    ],
    "Ranger-Crew-XP-1000-High-Lifter-Edition": [
      "2022",
      "2021",
      "2020"
    ],
    "Ranger-Crew-XP-1000-Texas-Edition": [
      "2022",
      "2021",
      "2020",
      "2019"
    ],
    "Ranger-1000-EPS": [
      "2023",
      "2022",
      "2021",
      "2020"
    ],
    "Ranger-1000-Premium": [
      "2023",
      "2022",
      "2021",
      "2020"
    ],
    "Ranger-Crew-XP-1000-Premium": [
      "2023",
      "2022",
      "2021",
      "2020"
    ],
    "Ranger-Crew-XP-1000-Trail-Boss": [
      "2022",
      "2021"
    ],
    "Ranger-Crew-XP-1000-NorthStar-Edition-Trail-Boss": [
      "2023",
      "2022",
      "2021"
    ],
    "Ranger-Crew-XP-1000-NorthStar-Premium": [
      "2023",
      "2022",
      "2021"
    ],
    "Ranger-Crew-XP-1000-NorthStar-Ultimate": [
      "2023",
      "2022",
      "2021"
    ],
    "Ranger-1000-Premium-+-Winter-Prep-Package": [
      "2022"
    ],
    "Ranger-Crew-XP-1000-Big-Game-Edition": [
      "2022"
    ],
    "Ranger-Crew-XP-1000-NorthStar-Big-Game-Edition": [
      "2022"
    ],
    "Ranger-Crew-XP-1000-Waterfowl-Edition": [
      "2022"
    ],
    "XPEDITION-ADV-5-Northstar": [
      "2024"
    ],
    "XPEDITION-ADV-5-Premium": [
      "2024"
    ],
    "XPEDITION-ADV-5-Ultimate": [
      "2024"
    ],
    "XPEDITION-ADV-Northstar": [
      "2024"
    ],
    "XPEDITION-ADV-Premium": [
      "2024"
    ],
    "XPEDITION-ADV-Ultimate\\_x000D_\\": [
      "2024"
    ],
    "XPEDITION-ADV-5-Ultimate\\_x000D_\\": [
      "2024"
    ],
    "RZR-XP-1000": [
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014"
    ],
    "RZR-XP-1000-EPS": [
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014"
    ],
    "RZR-XP-1000-EPS-Desert-Edition": [
      "2015"
    ],
    "RZR-XP-1000-EPS-DYNAMIX-Edition": [
      "2019"
    ],
    "RZR-XP-1000-EPS-Fox-Edition": [
      "2015"
    ],
    "RZR-XP-1000-EPS-Gold-Matte-Metallic-LE": [
      "2017"
    ],
    "RZR-XP-1000-EPS-High-Lifter-Edition": [
      "2019",
      "2018",
      "2017",
      "2016",
      "2015"
    ],
    "RZR-XP-1000-EPS-Ride-Command-Edition": [
      "2019",
      "2018"
    ],
    "RZR-XP-1000-EPS-Trails-and-Rock-Edition": [
      "2019",
      "2018"
    ],
    "RZR-XP-1000-EPS-Velocity-Blue-LE": [
      "2017"
    ],
    "RZR-XP-1000-High-Lifter": [
      "2022"
    ],
    "RZR-XP-1000-High-Lifter-Edition": [
      "2021",
      "2020"
    ],
    "RZR-XP-1000-Limited-Edition": [
      "2020"
    ],
    "RZR-XP-1000-Premium": [
      "2024",
      "2023",
      "2022",
      "2021",
      "2020"
    ],
    "RZR-XP-1000-Sport": [
      "2024",
      "2023",
      "2022"
    ],
    "RZR-XP-1000-Trails-&-Rocks": [
      "2022",
      "2021"
    ],
    "RZR-XP-1000-Trails-and-Rock-Edition": [
      "2020"
    ],
    "RZR-XP-1000-Ultimate": [
      "2024",
      "2023"
    ],
    "RZR-XP-4-1000": [
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014"
    ],
    "RZR-XP-4-1000-EPS": [
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014"
    ],
    "RZR-XP-4-1000-EPS-DYNAMIX-Edition": [
      "2019"
    ],
    "RZR-XP-4-1000-EPS-High-Lifter-Edition": [
      "2019",
      "2018",
      "2017"
    ],
    "RZR-XP-4-1000-EPS-Ride-Command-Edition": [
      "2019",
      "2018"
    ],
    "RZR-XP-4-1000-High-Lifter": [
      "2022"
    ],
    "RZR-XP-4-1000-High-Lifter-Edition": [
      "2021",
      "2020"
    ],
    "RZR-XP-4-1000-Limited-Edition": [
      "2020"
    ],
    "RZR-XP-4-1000-Premium": [
      "2024",
      "2023",
      "2022",
      "2021",
      "2020"
    ],
    "RZR-XP-4-1000-Sport": [
      "2024",
      "2023",
      "2022"
    ],
    "RZR-XP-4-1000-Ultimate": [
      "2024",
      "2023"
    ],
    "RZR-Turbo-S": [
      "2022",
      "2021"
    ],
    "RZR-Turbo-S-Lifted-Lime-LE": [
      "2021"
    ],
    "RZR-Turbo-S-Velocity": [
      "2022",
      "2021"
    ],
    "RZR-Turbo-S4": [
      "2022",
      "2021"
    ],
    "RZR-Turbo-S4-Lifted-Lime-LE": [
      "2021"
    ],
    "RZR-Turbo-S4-Velocity": [
      "2022",
      "2021"
    ],
    "RZR-XP-4-Turbo-S": [
      "2020"
    ],
    "RZR-XP-4-Turbo-S-Velocity": [
      "2020"
    ],
    "RZR-XP-Turbo-S": [
      "2020",
      "2019",
      "2018"
    ],
    "RZR-XP-Turbo-S-Velocity": [
      "2020"
    ],
    "RZR-XP-4-1000-Ultimate\\_x000D_\\": [
      "2024"
    ],
    "Ranger-Crew-XP-1000-NorthStar-Crew": [
      "2022",
      "2021",
      "2020",
      "2019"
    ],
    "Ranger-Crew-XP-1000-Back-Contry-Edition": [
      "2019"
    ],
    "Ranger-XP-1000--Back-Country": [
      "2019"
    ],
    "Ranger-Crew-XP-1000-High-Lifter-Edition-Crew": [
      "2022",
      "2021",
      "2020",
      "2019"
    ],
    "Ranger-XP-1000-Texas-Edition\\_x000D_\\": [
      "2021",
      "2020"
    ],
    "Ranger-Crew-XP-900": [
      "2019",
      "2018",
      "2017"
    ],
    "Ranger-RZR-800-S": [
      "2013",
      "2012",
      "2011",
      "2010",
      "2009"
    ],
    "Ranger-RZR-800-S-LE": [
      "2013",
      "2012"
    ],
    "RZR-Turbo-R-4-Premium": [
      "2023",
      "2022"
    ],
    "RZR-Turbo-R-4-Sport": [
      "2023",
      "2022"
    ],
    "RZR-Turbo-R-4-Ultimate": [
      "2023",
      "2022"
    ],
    "RZR-Turbo-R-Premium": [
      "2023"
    ],
    "RZR-Turbo-R-Sport": [
      "2023",
      "2022"
    ],
    "RZR-Turbo-R-Ultimate": [
      "2023",
      "2022"
    ],
    "Ranger-RZR-800": [
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008"
    ],
    "Ranger-800-HD": [
      "2010"
    ],
    "Ranger-RZR-800-EPS": [
      "2010"
    ],
    "Ranger-6x6-800": [
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010"
    ],
    "Ranger-800-Crew": [
      "2014",
      "2013",
      "2012",
      "2011",
      "2010"
    ],
    "Ranger-800-Crew-EPS": [
      "2012",
      "2011",
      "2010"
    ],
    "Ranger-800-XP": [
      "2012",
      "2011",
      "2010"
    ],
    "Ranger-800-XP-EPS": [
      "2012",
      "2011",
      "2010"
    ],
    "Ranger-RZR-4-800-Gordon-Edition": [
      "2012",
      "2011",
      "2010"
    ],
    "Ranger-RZR-4-800-EPS-Robby-Gordon": [
      "2011"
    ],
    "Ranger-800-HD-EPS": [
      "2012",
      "2011"
    ],
    "Ranger-800-Crew-EPS-LE": [
      "2013",
      "2012"
    ],
    "Ranger-800-XP-EPS-LE": [
      "2012"
    ],
    "Ranger-800-XP-LE": [
      "2012"
    ],
    "Ranger-RZR-4-800-EPS-Robby-Gordon-LE": [
      "2012"
    ],
    "Ranger-RZR-800-EPS-LE": [
      "2012"
    ],
    "Ranger-RZR-800-LE": [
      "2012"
    ],
    "Ranger-RZR-4-800": [
      "2013",
      "2012"
    ],
    "Ranger-800-EFI": [
      "2014",
      "2013"
    ],
    "Ranger-800-EFI-EPS": [
      "2013"
    ],
    "Ranger-800-EFI-EPS-LE": [
      "2014",
      "2013"
    ],
    "Ranger-800-EFI-LE": [
      "2013"
    ],
    "Ranger-800-EFI-Mid-Size-LE": [
      "2013"
    ],
    "Ranger-RZR-4-800-EPS-LE": [
      "2013"
    ],
    "Ranger-RZR-S-800-EPS-LE": [
      "2013"
    ],
    "Ranger-800-EFI-Mid-Size": [
      "2014",
      "2013"
    ],
    "Ranger-800-EPS-Mid-Size-LE": [
      "2014"
    ],
    "RZR-4-800-EPS-LE": [
      "2014"
    ],
    "RZR-800": [
      "2014"
    ],
    "RZR-800-EPS-LE": [
      "2014"
    ],
    "RZR-800-XC-Edition": [
      "2014"
    ],
    "RZR-S-800": [
      "2014"
    ],
    "RZR-S-800-EPS-LE": [
      "2014"
    ],
    "RZR-Pro-R": [
      "2022"
    ],
    "RZR-Pro-R-4": [
      "2022"
    ],
    "RZR-Pro-R-4-Premium": [
      "2023",
      "2022"
    ],
    "RZR-Pro-R-4-Ultimate": [
      "2023",
      "2022"
    ],
    "RZR-Pro-R-4-Ultimate-Launch-Edition": [
      "2022"
    ],
    "RZR-Pro-R-Premium": [
      "2023",
      "2022"
    ],
    "RZR-Pro-R-Ultimate": [
      "2023",
      "2022"
    ],
    "RZR-Pro-R-Ultimate-Launch-Edition": [
      "2022"
    ],
    "RZR-XP-4-Turbo": [
      "2021",
      "2020"
    ],
    "RZR-PRO-XP": [
      "2021",
      "2020"
    ],
    "RZR-PRO-XP-4": [
      "2021",
      "2020"
    ],
    "Ranger-900-Crew-EPS-LE": [
      "2014"
    ],
    "Ranger-900-Crew": [
      "2015",
      "2014"
    ],
    "Ranger-900-Crew-EPS": [
      "2015",
      "2014"
    ],
    "Ranger-900-6-Crew": [
      "2016",
      "2015"
    ],
    "Ranger-900-6-Crew-EPS": [
      "2016",
      "2015"
    ],
    "Ranger-900-5-Crew": [
      "2016"
    ],
    "Ranger-900-5-Crew-EPS": [
      "2016"
    ],
    "Ranger-Crew-XP-900-EPS": [
      "2019",
      "2018",
      "2017"
    ],
    "RZR-Pro-XP-Ultimate-Rockford-Fosgate-LE": [
      "2022"
    ],
    "RZR-PRO-XP-Ultimate": [
      "2023",
      "2022",
      "2021",
      "2020"
    ],
    "RZR-PRO-XP-Sport-Rockford-Fosgate-LE": [
      "2021"
    ],
    "RZR-PRO-XP-Sport": [
      "2023",
      "2022",
      "2021"
    ],
    "RZR-PRO-XP-Premium": [
      "2023",
      "2022",
      "2021",
      "2020"
    ],
    "RZR-PRO-XP-Orange-Madness-LE": [
      "2020"
    ],
    "General-1000-EPS": [
      "2019",
      "2018",
      "2017",
      "2016"
    ],
    "General-1000-EPS-Deluxe": [
      "2019",
      "2018",
      "2017",
      "2016"
    ],
    "General-1000-EPS-Hunter-Edition": [
      "2019",
      "2018",
      "2017"
    ],
    "General-1000-EPS-Ride-Command-Edition": [
      "2019",
      "2018",
      "2017"
    ],
    "General-4-1000-EPS": [
      "2019",
      "2018",
      "2017"
    ],
    "General-1000-EPS-Premium": [
      "2019",
      "2018"
    ],
    "General-4-1000-EPS-Ride-Command-Edition": [
      "2019",
      "2018"
    ],
    "General-1000-EPS-Limited-Edition": [
      "2019"
    ],
    "General-1000": [
      "2021",
      "2020"
    ],
    "General-1000-Deluxe": [
      "2022",
      "2021",
      "2020"
    ],
    "General-1000-Premium": [
      "2022",
      "2021",
      "2020"
    ],
    "General-1000-Sport": [
      "2023",
      "2022",
      "2020"
    ],
    "General-4-1000": [
      "2020"
    ],
    "General-4-1000-Deluxe": [
      "2021",
      "2020"
    ],
    "General-XP-1000-Deluxe": [
      "2022",
      "2021",
      "2020"
    ],
    "General-XP-4-1000-Deluxe": [
      "2022",
      "2021",
      "2020"
    ],
    "General-4-1000-Premium": [
      "2022",
      "2021"
    ],
    "General-XP-1000": [
      "2021"
    ],
    "General-XP-1000-Factory-Custom-Edition": [
      "2021"
    ],
    "General-XP-1000-Pursuit-Edition": [
      "2021"
    ],
    "General-XP-4-1000-Factory-Custom-Edition": [
      "2021"
    ],
    "General-XP-4-1000-Pursuit-Edition": [
      "2021"
    ],
    "General-1000-Deluxe-Ride-Command-Edition": [
      "2022"
    ],
    "General-4-1000-Deluxe-Ride-Command-Edition": [
      "2022"
    ],
    "General-XP-1000-Deluxe-Ride-Command-Edition": [
      "2022"
    ],
    "General-XP-1000-Trailhead-Edition": [
      "2022"
    ],
    "General-XP-1000-Troy-Lee-Designs-Edition": [
      "2022"
    ],
    "General-XP-4-1000-Deluxe-Ride-Command-Edition": [
      "2022"
    ],
    "General-XP-4-1000-Trailhead-Edition": [
      "2022"
    ],
    "General-XP-4-1000-Troy-Lee-Designs-Edition": [
      "2022"
    ],
    "General-XP-1000-Premium": [
      "2023"
    ],
    "General-XP-1000-Sport": [
      "2023"
    ],
    "General-XP-1000-Ultimate": [
      "2023"
    ],
    "General-XP-4-1000-Premium": [
      "2023"
    ],
    "General-XP-4-1000-Sport": [
      "2023"
    ],
    "General-XP-4-1000-Ultimate": [
      "2023"
    ],
    "RZR-XP-Turbo": [
      "2021",
      "2020"
    ],
    "RZR-XP-4-Turbo-EPS": [
      "2019",
      "2018",
      "2017",
      "2016"
    ],
    "RZR-XP-4-Turbo-EPS-DYNAMIX-Edition": [
      "2019",
      "2018"
    ],
    "RZR-XP-4-Turbo-EPS-LE": [
      "2019"
    ],
    "RZR-XP-Turbo-EPS": [
      "2019",
      "2018",
      "2017",
      "2016"
    ],
    "RZR-XP-Turbo-EPS-DYNAMIX-Edition": [
      "2019",
      "2018"
    ],
    "RZR-XP-Turbo-EPS-LE": [
      "2019"
    ],
    "RZR-XP-4-Turbo-EPS-Fox-Edition": [
      "2018"
    ],
    "RZR-XP-Turbo-EPS-Fox-Edition": [
      "2018"
    ],
    "Ranger-RZR-170": [
      "2013",
      "2012",
      "2011",
      "2010",
      "2009"
    ],
    "RZR-170": [
      "2014"
    ],
    "RZR-170-EFI": [
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015"
    ],
    "General": [
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016"
    ],
    "RZR-1000XP": [
      "2021",
      "2020",
      "2019",
      "2018"
    ],
    "RZR-PRO-R": [
      "2022"
    ],
    "Ranger-1000XP": [
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013"
    ],
    "RZR-Pro-XP-4-Ultimate-Rockford-Fosgate-LE": [
      "2022"
    ],
    "RZR-PRO-XP-4-Ultimate": [
      "2023",
      "2022",
      "2021",
      "2020"
    ],
    "RZR-PRO-XP-4-Sport": [
      "2023",
      "2022"
    ],
    "RZR-PRO-XP-4-Premium": [
      "2023",
      "2022",
      "2021",
      "2020"
    ],
    "RZR-PRO-XP-4-Orange-Madness-LE": [
      "2020"
    ],
    "RZR-570": [
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014"
    ],
    "Ranger-EV": [
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010"
    ],
    "Ranger-570-Crew": [
      "2015",
      "2014"
    ],
    "Ranger-ETX": [
      "2016",
      "2015"
    ],
    "Ranger-500": [
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017"
    ],
    "Ranger-Crew-SP-570": [
      "2023",
      "2022"
    ],
    "Ranger-SP-570": [
      "2023",
      "2022"
    ],
    "Ranger-570-XP": [
      "2016"
    ],
    "RZR-1000": [
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013"
    ],
    "RZR-900": [
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013"
    ],
    "Ranger-1000XP-High-Lifter": [
      "2020",
      "2019",
      "2018",
      "2017",
      "2016"
    ],
    "Ranger-570": [
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013"
    ],
    "Ranger-900XP": [
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013"
    ]
  },
  "Segway": {
    "UT10-P": [
      "2025"
    ]
  },
  "Tesla": {
    "Cybertruck": [
      "2025",
      "2024"
    ]
  },
  "Can-Am": {
    "Defender-DPS-HD10": [
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2018",
      "2017",
      "2016"
    ],
    "Defender-DPS-HD8": [
      "2021",
      "2020",
      "2018",
      "2017",
      "2016"
    ],
    "Defender-HD10": [
      "2018",
      "2017",
      "2016"
    ],
    "Defender-HD8": [
      "2021",
      "2020",
      "2018",
      "2017",
      "2016"
    ],
    "Defender-XT-CAB-HD10": [
      "2020",
      "2019",
      "2018",
      "2017",
      "2016"
    ],
    "Defender-XT-HD10": [
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016"
    ],
    "Defender-XT-HD8": [
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016"
    ],
    "Defender-HD10-Mossy-Oak-Hunting-Edition": [
      "2020",
      "2019",
      "2018",
      "2017"
    ],
    "Defender-DPS-HD5": [
      "2021",
      "2020",
      "2019",
      "2018",
      "2017"
    ],
    "Defender-HD5": [
      "2021",
      "2020",
      "2019",
      "2018",
      "2017"
    ],
    "Defender-MAX-HD8-DPS": [
      "2021",
      "2020",
      "2019",
      "2018",
      "2017"
    ],
    "Defender-MAX-HD8-XT": [
      "2021",
      "2020",
      "2019",
      "2018",
      "2017"
    ],
    "Defender-MAX-HD10-DPS": [
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017"
    ],
    "Defender-MAX-HD10-XT": [
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017"
    ],
    "Defender-HD10-XT-P": [
      "2020",
      "2019",
      "2018"
    ],
    "Defender-MAX-HD10-XT-CAB": [
      "2020",
      "2019",
      "2018"
    ],
    "Defender-XT-CAB-HD8": [
      "2020",
      "2019",
      "2018"
    ],
    "Defender-MAX-HD8": [
      "2021",
      "2020",
      "2019",
      "2018"
    ],
    "Defender-HD10-X-mr": [
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018"
    ],
    "Defender-MAX-HD10-Lone-Star": [
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018"
    ],
    "Defender-PRO-HD10": [
      "2022",
      "2021",
      "2020"
    ],
    "Defender-HD10-6X6-DPS": [
      "2024",
      "2023",
      "2022",
      "2021",
      "2020"
    ],
    "Defender-HD10-Limited": [
      "2024",
      "2023",
      "2022",
      "2021",
      "2020"
    ],
    "Defender-MAX-HD10-Limited": [
      "2024",
      "2023",
      "2022",
      "2021",
      "2020"
    ],
    "Defender-MAX-HD10-X-mr": [
      "2024",
      "2023",
      "2022",
      "2021",
      "2020"
    ],
    "Defender-PRO-HD10-XT": [
      "2024",
      "2023",
      "2022",
      "2021",
      "2020"
    ],
    "Defender-DPS-HD8-CAB": [
      "2021"
    ],
    "Defender-HD10-6X6-XT": [
      "2024",
      "2023",
      "2022",
      "2021"
    ],
    "Defender-PRO-HD10-Lone-Star": [
      "2022"
    ],
    "Defender-DPS-HD7": [
      "2024",
      "2023",
      "2022"
    ],
    "Defender-DPS-HD9": [
      "2024",
      "2023",
      "2022"
    ],
    "Defender-DPS-HD9-CAB": [
      "2023",
      "2022"
    ],
    "Defender-HD10-XT": [
      "2024",
      "2023",
      "2022"
    ],
    "Defender-HD7": [
      "2024",
      "2023",
      "2022"
    ],
    "Defender-HD9": [
      "2024",
      "2023",
      "2022"
    ],
    "Defender-MAX-HD7": [
      "2024",
      "2023",
      "2022"
    ],
    "Defender-MAX-HD9": [
      "2024",
      "2023",
      "2022"
    ],
    "Defender-MAX-HD9-DPS": [
      "2024",
      "2023",
      "2022"
    ],
    "Defender-MAX-HD9-XT": [
      "2024",
      "2023",
      "2022"
    ],
    "Defender-PRO-HD10-Limited": [
      "2024",
      "2023",
      "2022"
    ],
    "Defender-XT-HD9": [
      "2023",
      "2022"
    ],
    "Defender-HD10-6X6-Limited": [
      "2024",
      "2023"
    ],
    "Defender-HD10-X-mr-with-Doors": [
      "2024",
      "2023"
    ],
    "Defender-MAX-HD10-Lone-Star-CAB": [
      "2024",
      "2023"
    ],
    "Defender-MAX-HD10-X-mr-with-Doors": [
      "2024",
      "2023"
    ],
    "Defender-PRO-HD10-DPS": [
      "2024",
      "2023"
    ],
    "Defender-PRO-HD10-XT\\_x000D_\\": [
      "2024",
      "2023",
      "2022",
      "2021",
      "2020"
    ],
    "Defender-XT-HD9\\_x000D_\\": [
      "2024",
      "2023",
      "2022"
    ],
    "Maverick-Trail-1000": [
      "2020",
      "2019"
    ],
    "Maverick-Trail-1000-DPS": [
      "2023",
      "2022",
      "2021",
      "2020",
      "2019"
    ],
    "Maverick-Trail-1000R": [
      "2018"
    ],
    "Maverick-Trail-1000R-DPS": [
      "2018"
    ],
    "Maverick-Trail-700": [
      "2023",
      "2022"
    ],
    "Maverick-Trail-700-DPS": [
      "2023",
      "2022"
    ],
    "Maverick-Trail-800": [
      "2021",
      "2020",
      "2019"
    ],
    "Maverick-Trail-800-DPS": [
      "2021",
      "2020",
      "2019"
    ],
    "Maverick-Trail-800R": [
      "2018"
    ],
    "Maverick-Trail-800R-DPS": [
      "2018"
    ],
    "Maverick-Sport-1000": [
      "2022",
      "2021",
      "2020",
      "2019"
    ],
    "Maverick-Sport-1000-DPS": [
      "2020",
      "2019"
    ],
    "Maverick-Sport-1000R-DPS": [
      "2023",
      "2022",
      "2021",
      "2020",
      "2019"
    ],
    "Maverick-Sport-1000R-X-mr": [
      "2023",
      "2022",
      "2021",
      "2020"
    ],
    "Maverick-Sport-1000R-X-rc": [
      "2023",
      "2022",
      "2021",
      "2020"
    ],
    "Maverick-Sport-1000R-X-xc": [
      "2023",
      "2022",
      "2021",
      "2020"
    ],
    "Maverick-Sport-Max-1000R-DPS": [
      "2023",
      "2022",
      "2021",
      "2020"
    ],
    "Maverick-X3-Max-Turbo-R": [
      "2019",
      "2018",
      "2017"
    ],
    "Maverick-X3-Max-X-ds-Turbo-R": [
      "2019",
      "2018",
      "2017"
    ],
    "Maverick-X3-Max-X-rs-Turbo-R": [
      "2019",
      "2018",
      "2017"
    ],
    "Maverick-X3-Turbo-R": [
      "2019",
      "2018",
      "2017"
    ],
    "Maverick-X3-X-ds-Turbo-R": [
      "2019",
      "2018",
      "2017"
    ],
    "Maverick-X3-X-rs-Turbo-R": [
      "2019",
      "2018",
      "2017"
    ],
    "Maverick-X3-900-HO": [
      "2018"
    ],
    "Maverick-X3-X-rc-Turbo-R": [
      "2019",
      "2018"
    ],
    "Maverick-X3-Max-Turbo": [
      "2020",
      "2019",
      "2018"
    ],
    "Maverick-X3-Turbo": [
      "2020",
      "2019",
      "2018"
    ],
    "Maverick-X3-X-rc-Turbo": [
      "2021",
      "2020",
      "2019",
      "2018"
    ],
    "Maverick-X3-X-rc-Turbo-RR": [
      "2021",
      "2020"
    ],
    "Maverick-X3-Max-X-ds-Turbo-RR": [
      "2023",
      "2022",
      "2021",
      "2020"
    ],
    "Maverick-X3-MAX-X-MR-Turbo-RR": [
      "2023",
      "2022",
      "2021",
      "2020"
    ],
    "Maverick-X3-Max-X-rs-Turbo-RR": [
      "2023",
      "2022",
      "2021",
      "2020"
    ],
    "Maverick-X3-X-ds-Turbo-RR": [
      "2023",
      "2022",
      "2021",
      "2020"
    ],
    "Maverick-X3-X-rs-Turbo-RR": [
      "2023",
      "2022",
      "2021",
      "2020"
    ],
    "Maverick-X3-X-mr-Turbo-R": [
      "2019",
      "2018"
    ],
    "Maverick-X3-X-mr-Turbo": [
      "2021",
      "2020",
      "2019",
      "2018"
    ],
    "Maverick-X3-X-mr-Turbo-RR": [
      "2021",
      "2020"
    ],
    "Commander-1000": [
      "2014",
      "2013",
      "2012",
      "2011"
    ],
    "Commander-1000-XT": [
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011"
    ],
    "Commander-1000-DPS": [
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013"
    ],
    "Maverick-Max-1000R": [
      "2015",
      "2014"
    ],
    "Commander-1000-LTD": [
      "2016",
      "2015",
      "2014",
      "2013",
      "2012"
    ],
    "Commander-Max-1000-XT": [
      "2018",
      "2017",
      "2016",
      "2015",
      "2014"
    ],
    "Commander-1000-XT-P": [
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014"
    ],
    "Commander-Max-1000-DPS": [
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014"
    ],
    "Maverick-Max-1000R-Turbo": [
      "2017"
    ],
    "Commander-1000R-DPS": [
      "2023",
      "2022",
      "2021"
    ],
    "Commander-1000R-XT": [
      "2023",
      "2022",
      "2021"
    ],
    "Commander-1000R-XT-P": [
      "2023",
      "2022",
      "2021"
    ],
    "Commander-Max-1000R-DPS": [
      "2023",
      "2022",
      "2021"
    ],
    "Commander-Max-1000R-XT": [
      "2023",
      "2022",
      "2021"
    ],
    "Commander-1000R-X-mr": [
      "2023",
      "2022"
    ],
    "Commander-Max-1000R-XT-P": [
      "2023",
      "2022"
    ],
    "Renegade-800R": [
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010"
    ],
    "Renegade-1000": [
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012"
    ],
    "Renegade-500": [
      "2015",
      "2014",
      "2013",
      "2012"
    ],
    "Outlander-1000R-XT": [
      "2023"
    ],
    "Outlander-1000-6x6-XT": [
      "2018",
      "2017",
      "2016",
      "2015"
    ],
    "Outlander-1000-XT": [
      "2021",
      "2020",
      "2019",
      "2018",
      "2017"
    ],
    "Outlander-1000-X-mr": [
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013"
    ],
    "Outlander-1000-X-xc": [
      "2022",
      "2021",
      "2020",
      "2019",
      "2018"
    ],
    "Outlander-1000-DPS": [
      "2019",
      "2018",
      "2017"
    ],
    "Outlander-1000-EFI-XT": [
      "2016",
      "2015",
      "2014",
      "2013",
      "2012"
    ],
    "Outlander-1000-XT-P": [
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017"
    ],
    "Outlander-1000-EFI-XT-P": [
      "2016",
      "2015",
      "2014",
      "2013"
    ],
    "Outlander-1000-EFI": [
      "2012"
    ],
    "Outlander-1000-EFI-DPS": [
      "2016",
      "2015",
      "2014",
      "2013"
    ],
    "Outlander-570": [
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016"
    ],
    "Outlander-1000R-X-mr": [
      "2023"
    ],
    "Outlander-1000R-X-xc": [
      "2023"
    ],
    "Outlander-1000R-XT-P": [
      "2023"
    ],
    "Outlander-1000-Mossy-Oak-Hunting-Edition": [
      "2019",
      "2018",
      "2017"
    ],
    "Maverick-X3-Max-X-mr-Turbo-RR": [
      "2023",
      "2022",
      "2021",
      "2020"
    ],
    "Commander-1000-X": [
      "2013",
      "2012",
      "2011"
    ],
    "Maverick-Max-1000R-DPS": [
      "2018",
      "2017",
      "2016"
    ],
    "Maverick-Max-1000R-Turbo-X-ds": [
      "2017",
      "2016",
      "2015"
    ],
    "Maverick-Max-1000R-Turbo-X-rs": [
      "2017",
      "2016"
    ],
    "Maverick-Max-1000R-X-ds": [
      "2016",
      "2015"
    ],
    "Maverick-Max-1000R-X-mr": [
      "2018",
      "2017"
    ],
    "Maverick-Max-1000R-X-rs-DPS": [
      "2015"
    ],
    "Maverick-1000R": [
      "2016",
      "2015",
      "2014",
      "2013"
    ],
    "Maverick-1000R-DPS": [
      "2018",
      "2017",
      "2016"
    ],
    "Maverick-1000R-Turbo": [
      "2017"
    ],
    "Maverick-1000R-Turbo-X-ds": [
      "2016",
      "2015"
    ],
    "Maverick-1000R-Turbo-X-rs": [
      "2016"
    ],
    "Maverick-1000R-X-ds": [
      "2016",
      "2015"
    ],
    "Maverick-1000R-X-mr": [
      "2018",
      "2017"
    ],
    "Maverick-1000R-X-mr-DPS": [
      "2016",
      "2015"
    ],
    "Maverick-1000R-X-rs-DPS": [
      "2015"
    ],
    "Maverick-1000R-X-xc": [
      "2018",
      "2017"
    ],
    "Maverick-1000R-X-xc-DPS": [
      "2016",
      "2015"
    ],
    "Maverick-1000R-XC": [
      "2018",
      "2017",
      "2016"
    ],
    "Maverick-1000R-xc-DPS": [
      "2018",
      "2017"
    ],
    "Commander": [
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009"
    ],
    "Defender": [
      "2020",
      "2019",
      "2018",
      "2017",
      "2016"
    ]
  },
  "Mitsubishi": {
    "Raider": [
      "2009",
      "2008",
      "2007",
      "2006"
    ]
  },
  "Hummer": {
    "H3": [
      "2010",
      "2009",
      "2008",
      "2007",
      "2006"
    ]
  },
  "Mazda": {
    "B3000": [
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998"
    ],
    "B4000": [
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998"
    ]
  },
  "Daihatsu": {
    "Hijet-Jumbo": [
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014"
    ]
  },
  "Kawasaki": {
    "KRF1000-Teryx-KRX-1000": [
      "2023",
      "2022",
      "2021",
      "2020"
    ],
    "KRF800-Teryx": [
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015"
    ],
    "KRT1000-Teryx-KRX-4-1000-eS": [
      "2023"
    ],
    "KRT800-Teryx4": [
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014"
    ],
    "KRF1000-Teryx": [
      "2023",
      "2022",
      "2021",
      "2020"
    ],
    "KRT1000-Teryx": [
      "2023"
    ],
    "KRT800-Teryx4\\_x000D_\\": [
      "2023"
    ],
    "KRF800-Teryx-Camo": [
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016"
    ],
    "KRF800-Teryx-LE": [
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016"
    ],
    "KRT800-Teryx4-Camo": [
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016"
    ],
    "KRT800-Teryx4-LE": [
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016"
    ],
    "KRT800-Teryx4-S-Camo": [
      "2021"
    ],
    "KRF800-Teryx-S-LE": [
      "2023",
      "2022",
      "2021"
    ],
    "KRT800-Teryx4-S-LE": [
      "2023",
      "2022",
      "2021"
    ],
    "KRT800-Teryx4-S-Special-Edition": [
      "2023"
    ],
    "KAF820-Mule-PRO-FXT": [
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015"
    ],
    "KAF1000-Mule-PRO-DX-Diesel": [
      "2017",
      "2016"
    ],
    "KAF1000-Mule-PRO-DXT-Diesel": [
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016"
    ],
    "KAF820-Mule-PRO-FX": [
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016"
    ],
    "KAF820-Mule-PRO-FXT-Ranch-Edition": [
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016"
    ],
    "KAF820-Mule-PRO-FXT-EPS": [
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015"
    ],
    "KAF820-Mule-PRO-FXT-EPS-Camo": [
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015"
    ],
    "KAF820-Mule-PRO-FXT-EPS-LE": [
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015"
    ],
    "KAF820-Mule-PRO-FXT-Ranch-Edition-Platinum": [
      "2023",
      "2022"
    ],
    "KAF820-Mule-PRO-FXR": [
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018"
    ],
    "KAF820-Mule-PRO-FX-EPS": [
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016"
    ],
    "KAF820-Mule-PRO-FX-EPS-Camo": [
      "2017",
      "2016"
    ],
    "KAF820-Mule-PRO-FX-EPS-LE": [
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016"
    ],
    "KAF820-Mule-PRO-FX-Ranch-Edition": [
      "2017"
    ],
    "KAF1000-Mule-PRO-DX-EPS-Diesel": [
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016"
    ],
    "KAF1000-Mule-PRO-DX-EPS-LE-Diesel": [
      "2017",
      "2016"
    ],
    "KAF1000-Mule-PRO-DXT-EPS-Diesel": [
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016"
    ],
    "KAF1000-Mule-PRO-DXT-EPS-Diesel-FE": [
      "2023",
      "2022",
      "2021"
    ],
    "KAF1000-Mule-PRO-DXT-EPS-LE-Diesel": [
      "2017",
      "2016"
    ]
  },
  "Subaru": {
    "Crosstrek": [
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016"
    ],
    "Forester": [
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014"
    ],
    "Outback": [
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011"
    ],
    "XV-Crosstrek": [
      "2015",
      "2014",
      "2013"
    ]
  },
  "Yamaha": {
    "DR2A-The-Drive2-Fleet-EFI": [
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017"
    ],
    "DR2E-The-Drive2-Fleet-AC": [
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017"
    ],
    "DR2A-Drive2-Fleet-QuieTech-EFI": [
      "2022",
      "2021"
    ],
    "YXM700-Viking-FI-4x4": [
      "2015",
      "2014"
    ],
    "YXM700-Viking-FI-4x4-EPS": [
      "2015",
      "2014"
    ],
    "YXM700-Viking-FI-4x4-EPS-SE": [
      "2017",
      "2016",
      "2015",
      "2014"
    ],
    "YXM700-Viking-FI-4x4-EPS-with-Suntop": [
      "2017",
      "2016",
      "2015",
      "2014"
    ],
    "YXM700-Viking-FI-4x4-with-Suntop": [
      "2017",
      "2016",
      "2015",
      "2014"
    ],
    "YXM700-Viking-VI": [
      "2017",
      "2016",
      "2015"
    ],
    "YXM700-Viking-VI-EPS-SE": [
      "2017",
      "2016",
      "2015"
    ],
    "YXM700-Viking-VI-EPS": [
      "2019",
      "2018",
      "2017",
      "2016",
      "2015"
    ],
    "YXE70-Wolverine-R-Spec": [
      "2017",
      "2016"
    ],
    "YXE70-Wolverine-R-Spec-EPS-SE": [
      "2017",
      "2016"
    ],
    "YXE70-Wolverine": [
      "2018",
      "2017",
      "2016"
    ],
    "YXE70-Wolverine-R-Spec-EPS": [
      "2018",
      "2017",
      "2016"
    ],
    "YXM700-Viking-VI-EPS-Ranch-Edition": [
      "2019",
      "2018",
      "2017",
      "2016"
    ],
    "YXE70-Wolverine-EPS": [
      "2017"
    ],
    "YXM700-Viking-with-Suntop": [
      "2020",
      "2019",
      "2018"
    ],
    "YXM700-Viking-EPS-Ranch-Edition": [
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018"
    ],
    "YXM700-Viking-EPS-with-Suntop": [
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018"
    ],
    "YXM700-Viking-EPS-SE": [
      "2019"
    ],
    "YXC700-Viking-VI-EPS": [
      "2023",
      "2022",
      "2021",
      "2020"
    ],
    "YXC700-Viking-VI-EPS-Ranch-Edition": [
      "2023",
      "2022",
      "2021",
      "2020"
    ],
    "Rhino-660": [
      "2007",
      "2006",
      "2005",
      "2004"
    ],
    "Rhino-450": [
      "2008",
      "2007",
      "2006"
    ],
    "Rhino-700": [
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008"
    ],
    "Viking": [
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014"
    ]
  },
  "CFMoto": {
    "X8-(Terralander-800)": [
      "2012"
    ],
    "CForce-800": [
      "2014",
      "2013"
    ],
    "UForce-800": [
      "2016",
      "2015",
      "2014",
      "2013"
    ],
    "ZForce-800-EX": [
      "2016",
      "2015",
      "2014"
    ],
    "ZForce-800": [
      "2016",
      "2015"
    ],
    "ZForce-800-EPS": [
      "2016",
      "2015"
    ],
    "CForce-800-EPS": [
      "2017",
      "2016",
      "2015"
    ],
    "UForce-800-EPS": [
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015"
    ],
    "ZForce-800-EX-EPS": [
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015"
    ],
    "ZForce-800-Trail": [
      "2016"
    ],
    "ZForce-800-EPS-Trail": [
      "2017",
      "2016"
    ],
    "CForce-800-XC": [
      "2018"
    ],
    "Zforce-800-Trail-EPS": [
      "2021",
      "2020",
      "2019",
      "2018"
    ]
  },
  "Mahindra": {
    "Roxor": [
      "2020",
      "2019",
      "2018"
    ],
    "ROXOR-A/T": [
      "2020"
    ],
    "ROXOR-All-Weather": [
      "2022"
    ],
    "ROXOR-Base": [
      "2022"
    ]
  },
  "Suzuki": {
    "Samurai": [
      "1995",
      "1994",
      "1993",
      "1992",
      "1991",
      "1990",
      "1989",
      "1988",
      "1987",
      "1986",
      "1985"
    ]
  },
  "Kubota": {
    "RTV-X1120D": [
      "2017",
      "2016",
      "2015",
      "2014"
    ],
    "RTV-X900-General-Purpose": [
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014"
    ],
    "RTV-X1140": [
      "2018",
      "2017",
      "2016"
    ],
    "RTV-X1120-Deluxe": [
      "2022",
      "2021",
      "2020",
      "2019",
      "2018"
    ],
    "RTV-X1140-Worksite": [
      "2022",
      "2021",
      "2020",
      "2019"
    ],
    "RTV-X900-Worksite": [
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014"
    ],
    "RTV-XG850-Sidekick-Worksite": [
      "2022",
      "2021",
      "2020",
      "2019",
      "2018"
    ],
    "RTV-XG850-Sidekick-General-Purpose": [
      "2022",
      "2021",
      "2020",
      "2019",
      "2018"
    ],
    "RTV-X1120-Worksite": [
      "2022",
      "2021",
      "2020",
      "2019",
      "2018"
    ],
    "RTV-X1120-General-Purpose": [
      "2022",
      "2021",
      "2020",
      "2019",
      "2018"
    ],
    "RTV-X1100C": [
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014"
    ],
    "RTV-XG850-Sidekick-Special": [
      "2020",
      "2019",
      "2018"
    ]
  }
};